import { LegalLayout, Section } from "@/components/LegalLayout";
import { CONTACT } from "@/data";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="August 2026">
      <p className="font-body text-navy/75 text-lg leading-relaxed">
        These Terms of Service govern your use of the {CONTACT.name} website and the quote request
        service offered through it. By using this website you agree to these terms.
      </p>

      <Section heading="1. Our Services">
        <p>
          {CONTACT.name} provides residential and commercial painting and refinishing services,
          including mailboxes, posts, light fixtures, garage doors, fences, railings and outdoor
          furniture, serving {CONTACT.area}. Photos and pricing shown on this site reflect past work
          and are examples only; every project is quoted individually.
        </p>
      </Section>

      <Section heading="2. Quote Requests">
        <p>
          Submitting the quote form is a request for an estimate, not a binding contract. Quotes are
          provided after we review your request and, where applicable, the photos you share. Pricing
          such as the $50 flat-rate mailbox repaint may be subject to upcharges depending on
          condition, size and materials, which we will confirm before any work begins.
        </p>
      </Section>

      <Section heading="3. Photos You Submit">
        <p>
          You may upload photos of your property to help us prepare a quote. By uploading, you confirm
          you have the right to share those images and you grant us permission to use them solely to
          evaluate and complete your request. We do not publish customer-submitted photos publicly
          without permission.
        </p>
      </Section>

      <Section heading="4. Accurate Information">
        <p>
          Please provide accurate contact details so we can respond to your request. We are not
          responsible for missed communication caused by incorrect information.
        </p>
      </Section>

      <Section heading="5. Limitation of Liability">
        <p>
          This website is provided "as is." To the fullest extent permitted by law, {CONTACT.name} is
          not liable for any indirect or incidental damages arising from use of this website. Nothing
          here limits your rights under any signed work agreement or applicable law.
        </p>
      </Section>

      <Section heading="6. Contact">
        <p>
          Questions about these terms? Call or text{" "}
          <a href={CONTACT.phoneHref} className="text-navy underline hover:text-gold">{CONTACT.phone}</a>{" "}
          or email{" "}
          <a href={`mailto:${CONTACT.email}`} className="text-navy underline hover:text-gold">{CONTACT.email}</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
